// This file was automatically generated from ptdata.patients.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.patients');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.patientTags');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.fullName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.firstName), ' ', soy.$$escapeHtml(opt_data.lastName));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.displayName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.firstName), ' ', (opt_data.middleName) ? soy.$$escapeHtml(opt_data.middleName[0]) + '. ' : '', soy.$$escapeHtml(opt_data.lastName));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.patientFacingName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.actualName) {
    output.append(soy.$$escapeHtml(opt_data.actualName));
  } else {
    el8.template.ptdata.patients.displayName({firstName: opt_data.firstName, middleName: opt_data.middleName, lastName: opt_data.lastName}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.mailingAddress = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(' ', soy.$$escapeHtml(opt_data.address), (opt_data.suite) ? ' ' + soy.$$escapeHtml(opt_data.suite) : '', (opt_data.city) ? ' ' + soy.$$escapeHtml(opt_data.city) + ',' : '', (opt_data.state) ? ' ' + soy.$$escapeHtml(opt_data.state) : '', (opt_data.zip) ? ' ' + soy.$$escapeHtml(opt_data.zip) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.reverseName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.lastName), ', ', soy.$$escapeHtml(opt_data.firstName), (opt_data.middleName) ? ' ' + soy.$$escapeHtml(opt_data.middleName) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.insuranceSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.insuranceCompany ? opt_data.insuranceCompany.carrier : ''), (opt_data.insurancePlan) ? ' ' + soy.$$escapeHtml(opt_data.insurancePlan.name) : '', (opt_data.memberId) ? ' ID: ' + soy.$$escapeHtml(opt_data.memberId) : '', (opt_data.groupId) ? ' Group: ' + soy.$$escapeHtml(opt_data.groupId) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.genderIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.sex == 'F') ? 'el8PtFemale' : 'el8PtMale');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.genderIconSmall = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.sex == 'F') ? 'el8PtFemaleSmall' : 'el8PtMaleSmall');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.patients.tag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8InlineItem el8TagWrap">');
  el8.template.appshared.patientTags.tag({tag: opt_data.tag}, output);
  output.append('</li>');
  if (!opt_sb) return output.toString();
};
